import getIn from '../components/connectedForm/utils/getIn';
import { Maybe } from '../graphql/schema/p4types';

/**
 * @deprecated This function should not be used, instead use the new (improved?) getEntryCount function.
 */
export function getCount({ values } = {} as { values: any }, field: string) {
  const value = getIn(values, field);
  return value && Array.isArray(value) ? value.filter((entry) => !entry?.archived).length : 0;
}

/**
 * Return the length of an array excluding any entries in the array that
 * have an archived property and that property is set to true.
 *
 * @remarks
 * If the array entry has no archived property it will be included in the
 * count returned.
 *
 * @param array - an array of objects which may or may not contain an archived
 *                property.
 * @param includeArchived - include in the count any entries that have an archived
 *                          property and that property is set to true
 *
 * @returns The number of entries in the array that match the criteria
 */
export const getEntryCount = (array: Maybe<Array<any>>, includeArchived: boolean = false): number => {
  if (array) {
    if (includeArchived) {
      return array.length;
    }
    return array.filter((entry) => {
      if ('archived' in entry) {
        return !entry.archived;
      }
      return true;
    }).length;
  }
  return 0;
};
